module.exports = __webpack_public_path__ + "img/Sailing.08e010f6.png";